import { render, staticRenderFns } from "./app-detail-download-shop.vue?vue&type=template&id=5e54eb8c&scoped=true&"
import script from "./app-detail-download-shop.vue?vue&type=script&lang=js&"
export * from "./app-detail-download-shop.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-download-shop.vue?vue&type=style&index=0&id=5e54eb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54eb8c",
  null
  
)

export default component.exports